import { languages } from "../translations/Languages";
export const getLanguageFromUrl = () => {
  let queryString = window.location.href.split("/");
  let languageRaw = queryString[queryString.length - 1];
  let language = languageRaw.length < 3 && languageRaw.length > 0 ? languageRaw : languages[0];
  return language;
};

export const accessCookie = (cookieName) => {
  var name = cookieName + "=";
  var allCookieArray = document.cookie.split(";");
  for (var i = 0; i < allCookieArray.length; i++) {
    var temp = allCookieArray[i].trim();
    if (temp.indexOf(name) === 0) return temp.substring(name.length, temp.length);
  }
  return "";
};

export function createCookie(cookieName, cookieValue) {
  let date = new Date();
  date.setTime(date.getTime() + 60 * 60 * 1000);
  document.cookie = cookieName + " = " + cookieValue + "; expires = " + date.toGMTString();
}

/*to be replaced with config*/
export const demoUrl = "https://demo.opseeker.com";
export const legalUrl = () => {
  let lang = getLanguageFromUrl();
  return "https://demo.opseeker.com/conf/" + (lang === "es" ? "" : lang + "/");
};
export const wordpressBlogPosts = "https://blog.opseeker.com/wp-json/wp/v2/posts?per_page=3";

export const scrollToElemnent = (scrollTo) => {
  const element = document.getElementById(scrollTo);
  element.scrollIntoView({ behavior: "smooth" });
};



// WEBPACK FOOTER //
// ./src/app/AppHelpers.js